'use client';

import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { LocaleLink } from '@/components/locale-link';
import { ShellTooltip } from './ShellTooltip';
import { useShellPlan } from './SidebarAccountMenu';
import { logSidebarClick, SHELL_FOCUS } from './SidebarNav';

export function SidebarUpgrade({
  rail = false,
  onNavigate,
}: {
  rail?: boolean;
  onNavigate?: () => void;
}) {
  const { free } = useShellPlan();
  const { t } = useTranslation();
  if (!free) return null;
  const onClick = () => {
    logSidebarClick('upgrade');
    onNavigate?.();
  };
  if (rail)
    return (
      <ShellTooltip label={t('navigation.upgradeTitle')}>
        <LocaleLink
          href="/plans"
          onClick={onClick}
          aria-label={t('navigation.upgradeTitle')}
          className={`mx-auto flex size-10 items-center justify-center rounded-md text-[var(--fd-accent-ink)] hover:bg-[var(--fd-bg)] ${SHELL_FOCUS}`}
        >
          <Sparkles className="size-[18px]" aria-hidden />
        </LocaleLink>
      </ShellTooltip>
    );
  return (
    <div className="mb-2 rounded-md border border-[var(--fd-line)] bg-[var(--fd-card)] p-3">
      <p className="text-sm font-medium">{t('navigation.upgradeTitle')}</p>
      <p className="mt-1 text-[11px] text-[var(--fd-muted)]">
        {t('navigation.upgradeBody')}
      </p>
      <LocaleLink
        href="/plans"
        onClick={onClick}
        className={`mt-2 flex min-h-10 items-center justify-center gap-2 rounded-md bg-[var(--fd-ink)] px-3 text-sm text-[var(--fd-card)] hover:bg-[var(--fd-ink-2)] ${SHELL_FOCUS}`}
      >
        <Sparkles className="size-4" aria-hidden />
        {t('navigation.upgradeCta')}
      </LocaleLink>
    </div>
  );
}
